import { api } from 'api'
import { toaster } from 'uikit/Toaster'
import { useMutation } from '@tanstack/react-query'

export const useFetchStats = () => {
  return useMutation({
    mutationFn: (data) => api.payments.fetchSum(data),
    onError: (err: any) => {
      toaster.create({
        type: 'error',
        title: 'Произошла ошибка при загрузке статистики',
        description: err.response?.data?.message || err.message,
      })
    },
    gcTime: 0,
  })
}
